import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidenav!: MatSidenav;
  private isExpandedSubject = new BehaviorSubject<boolean>(true);
  isExpanded$ = this.isExpandedSubject.asObservable();

  setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  open(): void {
    this.sidenav.open();
    this.isExpandedSubject.next(true);
  }

  close(): void {
    this.sidenav.close();
    this.isExpandedSubject.next(false);
  }

 toggle(): void {
    if (this.sidenav) {
      this.sidenav.toggle();
      const newState = !this.isExpandedSubject.value;
      this.isExpandedSubject.next(newState);
    }
  }
}
